export const formatNumber = (num: number | string, maximumFractionDigits = 2, minimumFractionDigits: number = 0) => {
  if (num === 0) {
    return '0.00';
  }

  return num ? Number(num).toLocaleString('en-US', { maximumFractionDigits, minimumFractionDigits }) : '-.----';
};
